// extracted by css-extract-rspack-plugin
export default {"anchor":"IconButtonSelector-module__anchor__ILOzU"};